import React from 'react';
import {useSearchParams, useNavigate} from 'react-router-dom';
import {Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import {PopularPaysLogoFull} from '@/components/unusual-icons';
import styles from './AuthError.module.scss';

function AuthError() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const errorMessage = searchParams.get('error');

  const handleTryAgain = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.logo}>
          <PopularPaysLogoFull />
        </div>

        <div className={styles.title}>
          {translate("We couldn't log you in")}
        </div>

        {errorMessage && <p className={styles.body}>{errorMessage}</p>}

        <Button
          appearance="brand"
          mode="filled"
          size="medium"
          onClick={handleTryAgain}
        >
          {translate('Try again')}
        </Button>
      </div>
    </div>
  );
}

export default AuthError;
